var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75923 6.48044C4.76093 5.65691 5.38355 4.91851 6.19176 4.77946C6.35748 4.75051 8.30138 4.75449 9.10563 4.75505C9.90136 4.75562 10.5796 5.04167 11.1415 5.60243C12.3345 6.79317 13.5264 7.98505 14.7165 9.17808C15.4209 9.88357 15.4305 10.9665 14.729 11.6742C13.7171 12.6958 12.7 13.7123 11.6789 14.7243C10.9718 15.4252 9.88887 15.4161 9.18281 14.7118C7.97901 13.5114 6.7752 12.311 5.57651 11.1055C5.11282 10.639 4.83926 10.0754 4.77853 9.41643C4.72971 8.88974 4.75809 6.93166 4.75923 6.48044Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77915 7.8506C8.77688 8.358 8.35291 8.77516 7.84041 8.77402C7.3313 8.77289 6.90733 8.34835 6.91017 7.84265C6.91358 7.31482 7.3313 6.90334 7.86254 6.90561C8.36653 6.90731 8.78142 7.33469 8.77915 7.8506Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.262b11f8cc6c7ffa8bc4f732a5a8477b.svg";
export { ForwardRef as ReactComponent };